<template lang="pug">
.register-certificate
  register-certificate-success(
    v-if="cetificateRequestedData"
  )
  validation-observer.register-certificate(
    v-else
    ref="obs"
    v-slot="{ failed, touched, untouched }"
  )
    .title.mb-4
      v-btn(fab small depressed).mr-2 1
      span Выбор муниципалитета
    v-autocomplete(
      v-model="selectedMun"
      name="municipality"
      label="Муниципалитет"
      :items="muns"
      item-text="name"
      filled
      rounded
      return-object
    )
    validation-provider(
      v-if="selectedMun"
      rules="required"
      name="Группа сертификата"
      v-slot="{ errors }"
    )
      v-autocomplete(
        v-model="certGroupId"
        label="Группа сертификата"
        :items="selectedMun.groups"
        item-text="name"
        item-value="id"
        filled
        rounded
      )
    .title.mb-4
      v-btn(fab small depressed).mr-2 2
      span Личная информация обучающегося

    validation-provider(
      rules="required|email"
      vid="email"
      name="Email"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="personalInfo.email"
        label="Адрес электронной почты"
        name="email"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required|email|confirmed:email"
      name="Email"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="personalInfo.email_confirm"
        label="Подтверждение почты"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required"
      name="Фамилия"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="personalInfo.lastChildName"
        label="Фамилия"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required"
      name="Имя"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="personalInfo.firstChildName"
        label="Имя"
        :error-messages="errors"
        filled
        rounded
      )
    v-text-field(
      v-model.trim="personalInfo.surChildName"
      label="Отчество"
      filled
      rounded
    )

    validation-provider(
      rules="required"
      name="Адрес регистрации"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="personalInfo.addressChild"
        label="Адрес регистрации"
        :error-messages="errors"
        filled
        rounded
      )

    validation-provider(
      rules="required"
      name="Дата рождения"
      v-slot="{ errors }"
    )
      v-datetime-field(
        v-model="personalInfo.birthChild"
        label-date="Дата рождения"
        only-date
        filled
        rounded
      )

    .title.mb-4
      v-btn(fab small depressed).mr-2 3
      span Документ обучающегося
    validation-provider(
      rules="required"
      name="Тип документа"
      v-slot="{ errors }"
    )
      v-select(
        v-model="document.type"
        label="Тип документа"
        :items="DOCUMENT_TYPES"
        filled
        rounded
      )
    validation-provider(
      v-if="document.type === DOCUMENT_TYPE.anotherDoc"
      rules="required"
      name="Документ"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="document.anotherDoc"
        label="Документ"
        :error-messages="errors"
        filled
        rounded
      )
    template(v-if="document.type === DOCUMENT_TYPE.doc")
      validation-provider(
        rules="required"
        name="Серия"
        v-slot="{ errors }"
      )
        v-text-field(
          v-model.trim="document.series"
          label="Серия"
          :error-messages="errors"
          persistent-hint
          hint="Для свидетельства о рождении: обязательно наличие тире '-'." +
            " Перед тире римские цифры написанные Английскими заглавными буквами I(i),V или X." +
            " После тире двузначный буквенный код, написанный заглавными Русскими буквами."
          filled
          rounded
        )
      validation-provider(
        rules="required"
        name="Номер"
        v-slot="{ errors }"
      )
        v-text-field(
          v-model.trim="document.number"
          label="Номер"
          :error-messages="errors"
          filled
          rounded
        )
    .title.mb-4
      v-btn(fab small depressed).mr-2 4
      span Данные заявителя
    validation-provider(
      rules="required"
      name="Фамилия"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="parent.lastParentName"
        label="Фамилия"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required"
      name="Имя"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="parent.firstParentName"
        label="Имя"
        :error-messages="errors"
        filled
        rounded
      )
    v-text-field(
      v-model.trim="parent.surParentName"
      label="Отчество"
      filled
      rounded
    )
    v-text-field(
      v-model.trim="parent.contactsParent"
      label="Контактные данные"
      filled
      rounded
    )
    captcha-field.mb-5(
      v-model="captcha"
      :data.sync="captchaData"
      :method="loadCaptcha"
      @inizialized="onCaptchaInit"
    )
    .d-flex
      slot(name="extra-actions")
      v-btn(
        :disabled="untouched || (failed && touched)"
        :loading="loadingBtn"
        rounded
        color="success"
        @click="sendRequest"
      ) Создать сертификат
</template>

<script>
import axios from 'axios';

import DatePicker from '@/components/InputFields/DatePicker.vue';
import CaptchaField from '@/components/InputFields/CaptchaField.vue';

import RegisterCertificateSuccess from './RegisterCertificateSuccess.vue';

const DOCUMENT_TYPE = {
  // Свидетельство о рождении
  doc: 1,
  // Документ иностранного образца
  anotherDoc: 2,
};

export default {
  name: 'RegisterCertificate',
  components: {
    DatePicker,
    CaptchaField,
    RegisterCertificateSuccess,
  },
  props: {
    apiUrl: { type: String, required: true },
  },
  data: () => ({
    muns: [],
    selectedMun: null,

    certGroupId: null,
    personalInfo: {},
    document: {},
    DOCUMENT_TYPES: [
      { text: 'Свидетельство о рождении', value: DOCUMENT_TYPE.doc },
      { text: 'Документ иностранного образца', value: DOCUMENT_TYPE.anotherDoc },
    ],
    DOCUMENT_TYPE,
    parent: {},

    cetificateRequestedData: null,

    captcha: null,
    captchaData: null,
    refreshCaptcha: null,

    loadingBtn: false,
  }),
  computed: {
    baseUrl() {
      const url = this.apiUrl.split('/');
      return `${url[0]}//${url[2]}`;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadMuns();
    },
    loadMuns() {
      this.$rHandler(
        axios.get(`${this.baseUrl}/api/v1/mun-groups`),
        ({ data }) => {
          this.muns = data.data;
        },
      );
    },
    async sendRequest() {
      this.loadingBtn = true;
      const payload = {
        munId: this.selectedMun.id,
        certGroupId: this.certGroupId,
        ...this.personalInfo,
        ...this.document,
        ...this.parent,

        termsOfUse: 'on',
        word: this.captcha,
        token: this.captchaData.token,
      };

      try {
        const resp = await axios.post(`${this.baseUrl}/api/v1/certificate-application`, payload);
        if (resp.data.result_code !== 'FLSCS') {
          const error = new Error('Запрос был обработан не успешно');
          error.response = resp;
          throw error;
        }
      } catch (e) {
        console.error(e.response);
        this.refreshCaptcha();
        if (e.response.status === 200) {
          if (e.response.data.result_code !== 'VAL01') {
            this.$toasted.error(e.response.data.result_message, { duration: 3000 });
          } else {
            e.response.data.errors.validation.forEach((i) => {
              this.$toasted.error(i, { duration: 3000 });
            });
          }
        } else {
          this.$toasted.error('Произошла неизвестная ошибка обратитель в техническую поддержку', { duration: 3000 });
        }
      }
      this.loadingBtn = false;
    },
    loadCaptcha() {
      return axios.get(`${this.baseUrl}/api/v1/captcha`);
    },
    onCaptchaInit(refreshCaptcha) {
      this.refreshCaptcha = refreshCaptcha;
    },
  },
};
</script>
